import React from 'react'
import MuiButton from '@mui/material/Button'
import {ButtonProps} from '@mui/material/Button/Button'
import styled from 'styled-components'
import {ThemeColorsHospitalic} from '@/assets/styles/color/ThemeColorsHospitalic'

type Props = ButtonProps & {
    icon: React.ReactNode
}

const Button = styled(MuiButton)`
    color: ${ThemeColorsHospitalic.PRIMARY_DARK};
    border-color: ${ThemeColorsHospitalic.PRIMARY_MAIN};

    &:not(:last-child) {
        margin-right: 10px;
    }
`

const CenteredDiv = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`

const CenteredDivWithPr = styled(CenteredDiv)`
    padding-right: 0.5em
`

export default function TableToolbarButton({children, icon, ...rest}: Props) {
    return (
        <Button size='small' variant='outlined' {...rest}>
            <CenteredDiv>
                <CenteredDivWithPr>{icon}</CenteredDivWithPr>
                <div>{children}</div>
            </CenteredDiv>
        </Button>
    )
}
